/**
 * Normalize a PathwayU company id for Set membership, comparisons, and API
 * payloads.
 * @param {unknown} id
 * @returns {string|null} Canonical string key, or null if missing/invalid.
 */
// eslint-disable-next-line import/prefer-default-export
export function normalizePathwayUCompanyId(id) {
  if (id === null || id === undefined) return null;
  const s = String(id).trim();
  return s.length === 0 ? null : s;
}
